import { type AppKitNetwork } from '@reown/appkit/networks'
import { HederaAdapter, HederaChainDefinition, hederaNamespace } from '@hashgraph/hedera-wallet-connect'
import { WC_PROJECT_ID } from './constants'

export const metadata = {
  name: 'Hedera Multisig Wallet',
  description: 'Hedera Multisig Wallet',
  url: typeof window !== 'undefined' && window.location ? window.location.origin : '',
  icons: ['https://storage.googleapis.com/currency-logos/logo-dark.svg'],
}

export const networks = [HederaChainDefinition.Native.Mainnet, HederaChainDefinition.Native.Testnet] as [
  AppKitNetwork,
  ...AppKitNetwork[],
]

export const nativeHederaAdapter = new HederaAdapter({
  projectId: WC_PROJECT_ID,
  networks: [HederaChainDefinition.Native.Mainnet, HederaChainDefinition.Native.Testnet],
  namespace: hederaNamespace,
})

export const eip155HederaAdapter = new HederaAdapter({
  projectId: WC_PROJECT_ID,
  networks: [HederaChainDefinition.EVM.Mainnet, HederaChainDefinition.EVM.Testnet],
  namespace: 'eip155',
})
